import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';


const AdminDashboardLayout = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    // Sidebar removed
  };

  return (
    <div className="">
      <div className="row g-0 flex-nowrap">
        {/* Sidebar Component Removed */}

        {/* Content Area - Will render child routes via Outlet */}
        <div 
          className="col py-3 px-4"
          style={{ 
            height: '100vh', 
            overflowY: 'auto',
            marginTop: isDesktop ? '80px' : '0',
            paddingTop: isDesktop ? '0' : '1rem'
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardLayout;